<template>
  <div class="login-container">
    <el-form class="login-form" :model="rulesForm" ref="loginForm">
      <div class="title-container">
        <h3 class="title">医院挂号预约系统</h3>
      </div>
      
      <el-form-item prop="username">
        <span class="svg-container">
          <svg-icon icon-class="user" />
        </span>
        <el-input 
          placeholder="请输入用户名" 
          name="username" 
          type="text" 
          v-model="rulesForm.username"
          prefix-icon="el-icon-user"
        />
      </el-form-item>
      
      <el-form-item prop="password">
        <span class="svg-container">
          <svg-icon icon-class="password" />
        </span>
        <el-input 
          placeholder="请输入密码" 
          name="password" 
          type="password" 
          v-model="rulesForm.password"
          prefix-icon="el-icon-lock"
          @keyup.enter.native="login()"
        />
      </el-form-item>
      
      <el-form-item v-if="roles.length>1" label="角色" prop="role" class="role-form">
        <el-radio
          v-for="item in roles"
          v-bind:key="item.roleName"
          v-model="rulesForm.role"
          :label="item.roleName"
        >{{item.roleName}}</el-radio>
      </el-form-item>
      
      <el-button 
        type="primary" 
        @click="login()" 
        class="login-btn"
        :loading="loading"
      >
        {{ loading ? '登录中...' : '登 录' }}
      </el-button>
    </el-form>
    
    <!-- 版权信息 -->
    <!-- <div class="copyright">
      Copyright © 2024 医院挂号预约系统 All Rights Reserved.
    </div> -->
    
    <!-- ICP 备案号 -->
    <div class="beian">
      <a href="https://beian.miit.gov.cn/" target="_blank">皖ICP备2026019914号-2</a>
    </div>
  </div>
</template>

<script>
import menu from "@/utils/menu";

export default {
  data() {
    return {
      rulesForm: {
        username: "",
        password: "",
        role: "",
      },
      menus: [],
      roles: [],
      tableName: "",
      loading: false
    };
  },
  mounted() {
    let menus = menu.list();
    this.menus = menus;
    for (let i = 0; i < this.menus.length; i++) {
      if (this.menus[i].hasBackLogin=='是') {
        this.roles.push(this.menus[i])
      }
    }
  },
  created() {
    
  },
  methods: {
    // 登陆
    login() {
      if (!this.rulesForm.username) {
        this.$message.error("请输入用户名");
        return;
      }
      if (!this.rulesForm.password) {
        this.$message.error("请输入密码");
        return;
      }
      
      if(this.roles.length>1) {
        if (!this.rulesForm.role) {
          this.$message.error("请选择角色");
          return;
        }
        let menus = this.menus;
        for (let i = 0; i < menus.length; i++) {
          if (menus[i].roleName == this.rulesForm.role) {
            this.tableName = menus[i].tableName;
          }
        }
      } else {
        this.tableName = this.roles[0].tableName;
        this.rulesForm.role = this.roles[0].roleName;
      }

      this.loading = true;
      this.$http({
        url: `${this.tableName}/login?username=${this.rulesForm.username}&password=${this.rulesForm.password}`,
        method: "post"
      }).then(({ data }) => {
        this.loading = false;
        if (data && data.code === 0) {
          this.$storage.set("Token", data.token);
          this.$storage.set("role", this.rulesForm.role);
          this.$storage.set("sessionTable", this.tableName);
          this.$storage.set("adminName", this.rulesForm.username);
          this.$router.replace({ path: "/index/" });
        } else {
          this.$message.error(data.msg);
        }
      }).catch(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.login-container {
  min-height: 100vh;
  width: 100%;
  overflow: hidden;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  
  // 背景装饰
  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjAiIGhlaWdodD0iNjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGNpcmNsZSBjeD0iMSIgY3k9IjEiIHI9IjEiIGZpbGw9InJnYmEoMjU1LDI1NSwyNTUsMC4xKSIvPjwvc3ZnPg==');
    opacity: 0.3;
  }
  
  .login-form {
    width: 400px;
    padding: 40px 35px 25px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    position: relative;
    z-index: 1;
    
    .title-container {
      text-align: center;
      margin-bottom: 30px;
      
      .title {
        font-size: 24px;
        color: #303133;
        font-weight: 600;
        margin: 0;
      }
    }
    
    ::v-deep .el-form-item {
      margin-bottom: 24px;
      
      .el-input {
        input {
          height: 44px;
          line-height: 44px;
          border-radius: 4px;
          border: 1px solid #dcdfe6;
          transition: all 0.3s;
          
          &:focus {
            border-color: #409EFF;
          }
        }
        
        .el-input__prefix {
          left: 12px;
          color: #909399;
        }
        
        input {
          padding-left: 40px;
        }
      }
    }
    
    .role-form {
      ::v-deep .el-form-item__label {
        color: #606266;
        font-size: 14px;
      }
      
      ::v-deep .el-radio {
        margin-right: 20px;
        
        .el-radio__label {
          color: #606266;
        }
      }
    }
    
    .login-btn {
      width: 100%;
      height: 44px;
      font-size: 16px;
      margin-top: 10px;
      background-color: #409EFF;
      border-color: #409EFF;
      transition: all 0.3s;
      
      &:hover {
        background-color: #66b1ff;
        border-color: #66b1ff;
      }
    }
  }
  
  .copyright,
  .beian {
    position: absolute;
    bottom: 20px;
    left: 0;
    right: 0;
    text-align: center;
    color: rgba(255, 255, 255, 0.8);
    font-size: 13px;
    z-index: 1;
  }
  
  .beian a {
    color: rgba(255, 255, 255, 0.9);
    text-decoration: none;
    
    &:hover {
      color: #fff;
      text-decoration: underline;
    }
  }
}

// 响应式设计
@media (max-width: 768px) {
  .login-container {
    .login-form {
      width: 90%;
      padding: 30px 25px 20px;
    }
  }
}
</style>
